/*============================================================================
  Setup the quick buy buttons
==============================================================================*/
function addQuantityInCollection() {
  const containerSelectors = ['div.grid-item__order-buttons', 'div.product-detail__order-buttons'];

  containerSelectors.forEach(containerSelector => {
    const containerItems = document.querySelectorAll(containerSelector);
    if (containerItems?.length > 0) {
      [...containerItems].forEach((container) => {
        if (container.hasAttribute('data-is-initialized')) {
          return;
        }

        const dropdowns = container.querySelectorAll('select');
        const orderButtons = container.querySelectorAll('button.order-button');

        if (dropdowns.length !== orderButtons.length) {
          console.error("Mismatch between number of dropdowns and order buttons");
          return;
        }

        for (let i = 0; i < orderButtons.length; i++) {
          const dropdown = dropdowns[i];
          const orderButton = orderButtons[i];
          const step = Number(dropdown.getAttribute('step'));
          orderButton.setAttribute('data-qty-step', step);

          orderButton.addEventListener('click', (e) => {
            const visibleBtn = e?.target;
            visibleBtn.classList.toggle('btn--loading', true);
            var id = visibleBtn.getAttribute('data-id');
            var qty = Number(dropdown.querySelector('option:checked')?.value);
          
            const dataLayerData = orderButton.getAttribute('data-datalayer-event').replace(/\s/g, '') ?? "[]"
            const parsedDataLayer = JSON.parse(dataLayerData);
          
            if (isNaN(qty)) {
              console.error("Invalid quantity ", qty);
              return;
            }
          
            var data = {
              items: [
                {
                  id: id,
                  quantity: qty,
                },
              ],
            };
          
            fetch('/cart/add.js', {
              method: 'POST',
              body: JSON.stringify(data),
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
              },
            })
              .then((response) => response.json())
              .then(function (data) {
                if (data.status === 422 || data.status === 'bad_request') {
                } else {
                  var product = data;
                  document.dispatchEvent(
                    new CustomEvent('ajaxProduct:added', {
                      detail: {
                        product: product,
                        addToCartBtn: visibleBtn,
                      },
                    })
                  );
                  // Trigger the datalayer events 
                  window.dataLayer.push({ ecommernce: null });
                  window.dataLayer.push(parsedDataLayer)
                }
                visibleBtn.classList.remove('btn--loading');
              })
              .catch((error) => {
                console.error("Error adding to cart: ", error);
                visibleBtn.classList.remove('btn--loading');
              });
          });
        }

        container.setAttribute('data-is-initialized', true);
      });
    }
  });
}

for (let eventName of ['DOMContentLoaded', 'page:loaded', 'recommendations:loaded', 'recentlyViewed:loaded', 'vendor:loaded']) {
  document.addEventListener(eventName, () => {
    addQuantityInCollection();
  });

  addQuantityInCollection();
}